"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageTwo;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _FinancialPlanningCheckupFormControls = require("./FinancialPlanningCheckupFormControls");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function FPCTPageTwo() {
  var {
    values: {
      hasEstatePlanningServices,
      hasTrustServices,
      hasTaxPlanning,
      hasSavingsAccount,
      hasHealthSavingsAccount,
      hasEducationSavingsAccount,
      hasLifeInsurance,
      hasLTCProtection,
      hasDisabilityIncomeInsurance,
      has401k,
      has403b,
      has457,
      hasIRA,
      hasPension,
      hasAnnuity,
      hasMoneyMarketCD,
      hasStocks,
      hasBonds,
      hasMutualFunds,
      hasETFs,
      hasOtherInvestments,
      productsOwnedList
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_FinancialPlanningCheckupWizardTool.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
    setFieldValue('hasNavigatedPage', true);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-page-2-desc col-lg-9 mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Assess your situation"), /*#__PURE__*/_react.default.createElement("p", null, "Your financial plan should be personalized to you and your goals. By gaining insight into your current financial strategy, you\u2019ll be better positioned to identify potential opportunities to help reach your financial objectives."), /*#__PURE__*/_react.default.createElement("p", null, "Select products and services that you currently use to help meet your financial goals."))), /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-page-2 mm-spacing"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("h5", null, "Financial Planning"), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.EstatePlanningServicesCheckBox, {
    hasEstatePlanningServices: hasEstatePlanningServices,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.TrustServicesCheckBox, {
    hasTrustServices: hasTrustServices,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.TaxPlanningCheckBox, {
    hasTaxPlanning: hasTaxPlanning,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("h5", null, "Savings"), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.SavingsAccountCheckBox, {
    hasSavingsAccount: hasSavingsAccount,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.HealthSavingsAccountCheckBox, {
    hasHealthSavingsAccount: hasHealthSavingsAccount,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.EducationSavingsAccountCheckBox, {
    hasEducationSavingsAccount: hasEducationSavingsAccount,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("h5", null, "Protection"), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.LifeInsuranceCheckBox, {
    hasLifeInsurance: hasLifeInsurance,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.LTCProtectionCheckBox, {
    hasLTCProtection: hasLTCProtection,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.DisabilityIncomeInsuranceCheckBox, {
    hasDisabilityIncomeInsurance: hasDisabilityIncomeInsurance,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("h5", null, "Retirement"), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.Retirement401kCheckBox, {
    has401k: has401k,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.Retirement403bCheckBox, {
    has403b: has403b,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.Retirement457CheckBox, {
    has457: has457,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.IRACheckBox, {
    hasIRA: hasIRA,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.PensionCheckBox, {
    hasPension: hasPension,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.AnnuityCheckBox, {
    hasAnnuity: hasAnnuity,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("h5", null, "Investments"), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.MoneyMarketCDCheckBox, {
    hasMoneyMarketCD: hasMoneyMarketCD,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.StocksCheckBox, {
    hasStocks: hasStocks,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.BondsCheckBox, {
    hasBonds: hasBonds,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.MutualFundsCheckBox, {
    hasMutualFunds: hasMutualFunds,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.ETFsCheckBox, {
    hasETFs: hasETFs,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  }), /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.OtherInvestmentsCheckBox, {
    hasOtherInvestments: hasOtherInvestments,
    setFieldValue: setFieldValue,
    productsOwnedList: productsOwnedList
  })))))));
}